import React, { useState } from "react";
import "@/App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CalendarPage from "./pages/CalendarPage";
import RequestsPage from "./pages/RequestsPage";
import EntriesPage from "./pages/EntriesPage";
import ProvidersPage from "./pages/ProvidersPage";
import Layout from "./components/Layout";

const AppContent = () => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  const [currentView, setCurrentView] = useState(null);

  // Set initial view based on role
  React.useEffect(() => {
    if (isAuthenticated && currentView === null) {
      setCurrentView(isAdmin() ? 'dashboard' : 'calendar');
    }
  }, [isAuthenticated, isAdmin, currentView]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <DashboardPage onNavigate={setCurrentView} />;
      case 'calendar':
        return <CalendarPage />;
      case 'requests':
        return <RequestsPage />;
      case 'entries':
        return <EntriesPage />;
      case 'settings':
        return <ProvidersPage />;
      default:
        return <CalendarPage />;
    }
  };

  return (
    <Layout currentView={currentView} onNavigate={setCurrentView}>
      {renderView()}
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
